import { Component, Input, OnInit } from '@angular/core';
import { IPost } from '../../../../../../models/post.model';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { CustomValidators } from '../../../../../customValidators';
import { DatePipe } from '@angular/common';
import { PostPromoteService } from '../../../../../../services/postPromote.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { PostPromote } from '../../../../../../models/postPromote.model';

@Component({
  selector: 'app-add-promote',
  templateUrl: './add-promote.component.html',
  styleUrls: ['./add-promote.component.scss']
})
export class AddPromoteComponent implements OnInit {

  @Input('posted')  posted:IPost | any;

  constructor(private fb: FormBuilder, private postPromoteService: PostPromoteService,private datePipe: DatePipe,private modalRef:BsModalRef,  private router: Router) { }

  ngOnInit(): void {
  }



  get getPost() { return this.postPromoteForm.controls; }

  postPromoteForm = this.fb.group({
    startDate : new FormControl("" , [Validators.required, CustomValidators.startDateNotBeforeToday]),
    endDate : new FormControl("" , [Validators.required]),
  });

  selectedStartDate : any;
  selectedEndDate : any;
  startDateNotAfterEndDate = false;
  startDateNotBeforeDateNow = false;
  endDateNotAfterStartDate = false;
  startDateNotEqualsEndDate = false;
  getSelectedDate() {
    this.selectedStartDate = this.postPromoteForm.get('startDate')?.value;
    if(this.selectedStartDate > this.selectedEndDate){
      this.startDateNotAfterEndDate = true;
    }
  }

  getSelectedEndDate() {
    const startDateString = this.postPromoteForm.get('startDate')?.value;
    const endDateString = this.postPromoteForm.get('endDate')?.value;

    // Conversion des chaînes en objets Date
    this.selectedStartDate = new Date(startDateString);
    this.selectedEndDate = new Date(endDateString);

    if (this.selectedStartDate > this.selectedEndDate) {
      this.startDateNotAfterEndDate = true;
    } else {
      this.startDateNotAfterEndDate = false;
    }

    if (this.selectedStartDate.getTime() === this.selectedEndDate.getTime()) {
      this.startDateNotEqualsEndDate = true;
    } else {
      this.startDateNotEqualsEndDate = false;
    }

    const oneHourInMilliseconds = 60 * 60 * 1000;

    if (this.selectedEndDate.getTime() - this.selectedStartDate.getTime() < oneHourInMilliseconds) {
      this.endDateNotAfterStartDate = true;
    } else {
      this.endDateNotAfterStartDate = false;
    }
  }

  minDate(): string {
    const today = new Date();
    return today.toISOString().slice(0, 16); // Format ISO pour la date et l'heure.
  }

  public onClose(): void {
    this.modalRef.hide();
  }

  onFormSubmit(): void {
      if(this.postPromoteForm.valid && !this.startDateNotAfterEndDate && !this.startDateNotEqualsEndDate && !this.endDateNotAfterStartDate){
        let postId = this.posted;
        let postMEA = new PostPromote();
        postId = this.posted.id ;
        postMEA.postId;
        postMEA.startDate = this.postPromoteForm.controls['startDate'].value;
        postMEA.endDate = this.postPromoteForm.controls['endDate'].value;
        this.postPromoteService.savePromote(postMEA, postId).subscribe(rs =>{
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Votre mise en avant a été appliquée avec succés.',
            showConfirmButton: false,
            timer: 1500
          });
          this.modalRef.hide();
          this.reloadComponent();
        }, error => {
          // console.log(error);
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: error.error.errorMessage,
            showConfirmButton: false,
            timer: 1500
          });
        });
      }else{
      }

  }
  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }
}
